<template>
  <div>
    <form
      ref="formRef"
      style="display: none"
      method="post"
      action="https://t.2c2p.com/RedirectV3/payment"
    >
      <input type="hidden" name="version" :value="version" />
      <input type="hidden" name="merchant_id" :value="merchant_id" />
      <input type="hidden" name="currency" :value="currency" />
      <input type="hidden" name="user_defined_1" :value="user_defined_1" />
      <input type="hidden" name="user_defined_2" :value="user_defined_2" />
      <input type="hidden" name="request_3ds" :value="request_3ds" />
      <input
        type="hidden"
        name="enable_store_card"
        :value="enable_store_card"
      />
      <input
        v-if="stored_card_unique_id"
        type="hidden"
        name="stored_card_unique_id"
        :value="stored_card_unique_id"
      />
      <input type="hidden" name="hash_value" :value="hash_value" />
      PRODUCT INFO :
      <input
        type="hidden"
        name="payment_description"
        :value="payment_description"
      /><br />
      ORDER NO :
      <input type="hidden" name="order_id" :value="order_id" /><br />
      AMOUNT:
      <input type="hidden" name="amount" :value="amount" /><br />
    </form>
  </div>
</template>

<script>
export default {
  name: "CreditCardForm",
  data() {
    return {
      amount: null,
      currency: null,
      hash_value: null,
      merchant_id: null,
      order_id: null,
      payment_description: null,
      request_3ds: null,
      enable_store_card: null,
      stored_card_unique_id: null,
      result_url_2: null,
      user_defined_1: null,
      user_defined_2: null,
      version: null,
    };
  },
  methods: {
    setInfo(info) {
      this.amount = info.amount;
      this.currency = info.currency;
      this.hash_value = info.hashValue;
      this.merchant_id = info.merchantId;
      this.order_id = info.orderId;
      this.payment_description = info.paymentDescription;
      this.request_3ds = info.request3ds;
      this.enable_store_card = info.enableStoreCard;
      this.stored_card_unique_id = info.storedCardUniqueId;
      this.result_url_2 = info.resultUrl2;
      this.user_defined_1 = info.userDefined1;
      this.user_defined_2 = info.userDefined2;
      this.version = info.version;
    },
    submit() {
      console.log("submit form", this.$refs.formRef);
      this.$nextTick(() => {
        this.$refs.formRef.submit();
      });
    },
  },
};
</script>
